module.exports = __webpack_public_path__ + "static/media/badge_yishu.c6d402ef.png";